module.exports = __webpack_public_path__ + "static/media/language.9a5a2a42.svg";